if (window.location.href.includes('/checkout')) {
  if (typeof $ == 'undefined') {
    javascript: (function (e, s) {
      e.src = s;
      e.onload = function () {
        $ = jQuery.noConflict();

      };
      document.head.appendChild(e);
    })(
      document.createElement('script'),
      'https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js'
    );
  }

    // detect utm
    function OtDetectAdsUrlTikTokPixel() {
      let isAdsUrl = false;
      const ARRAY_PARAMS_UTM = [
          "ttclid",
          "utm_source",
          "utm_campaign",
          "ad_group",
          "ad",
          "campaign_id",
          "ad_group_id",
          "ad_id",
      ];
      ARRAY_PARAMS_UTM.every((param) => {
          if (window.location.search.includes(param)) {
              isAdsUrl = true;
              return false;
          }
          return true;
      });
      return isAdsUrl;
  }
  
  function otSetCookieByAttributeWindowTikTokPixel(cname, cvalue) {
      const d = new Date();
      const exdays = otDetectAttributeWindowTikTokPixel();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  function otDetectAttributeWindowTikTokPixel() {
      if (typeof tikTokPixelCheckExpireApp !== "undefined") {
          return Math.max(1, parseInt(7, 10) || 14);
      }
      return 14;
  }
  
  function otDetectUTMUrlTikTokPixel() {
      var utmInfo = {
          ttclid: otDetectFieldTikTokPixel('ttclid'),
          utm_source: otDetectFieldTikTokPixel("utm_source"),
          utm_campaign: otDetectFieldTikTokPixel("utm_campaign"),
          ad_group: otDetectFieldTikTokPixel("ad_group") || otDetectFieldTikTokPixel('utm_terms'),
          ad: otDetectFieldTikTokPixel("ad") || otDetectFieldTikTokPixel('utm_contents'),
          campaign_id: otDetectFieldTikTokPixel("campaign_id"),
          ad_group_id: otDetectFieldTikTokPixel("ad_group_id"),
          ad_id: otDetectFieldTikTokPixel("ad_id"),
          
      };
  
      return utmInfo;
  }
  
  function otGetCookieTikTokPixel(cname) {
      let name = cname + "=";
      let decodedCookie = document.cookie;
      decodedCookie = document.cookie;
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == " ") {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  
  function otDetectUTMCookieTikTokPixel() {
      return {
          ttclid: otGetCookieTikTokPixel("ot_tik_tok_ttclid"),
          utm_source: otGetCookieTikTokPixel("ot_tik_tok_utm_source"),
          utm_campaign: otGetCookieTikTokPixel("ot_tik_tok_utm_campaign"),
          ad_group: otGetCookieTikTokPixel("ot_tik_tok_ad_group") || otGetCookieTikTokPixel('ot_tik_tok_utm_terms'),
          ad: otGetCookieTikTokPixel("ot_tik_tok_ad") || otGetCookieTikTokPixel('ot_tik_tok_utm_contents'),
          campaign_id: otGetCookieTikTokPixel("ot_tik_tok_campaign_id"),
          ad_group_id: otGetCookieTikTokPixel("ot_tik_tok_ad_group_id"),
          ad_id: otGetCookieTikTokPixel("ot_tik_tok_ad_id"),
      }
  }
  
  function otDetectFieldTikTokPixel(key_origin) {
      let value = ot_getUrlParam(key_origin);
     
      if (value != null && value != undefined) {
          otSetCookieByAttributeWindowTikTokPixel("ot_tik_tok_" + key_origin, value);
          return value;
      } else {
          otSetCookieByAttributeWindowTikTokPixel("ot_tik_tok_" + key_origin, '');
          return ''
      }
  }
  
  
  function otTikTokPixelDetectCampaign() {
      // check link come from ads
      const isComeFromAds = OtDetectAdsUrlTikTokPixel();
  
      return isComeFromAds ? otDetectUTMUrlTikTokPixel() : otDetectUTMCookieTikTokPixel();
  }
    // end detect utm 

  var rootLinkTikTokPixel = 'https://apps3.omegatheme.com/shopify/tiktok-multi-pixels/server.php';
  var rootAppPublicTikTokPixel = 'https://apps3.omegatheme.com/shopify/tiktok-multi-pixels/public';

  var pageURL = otConvertPageUrl();

  const EVENT_NAME_TOOL = {
    browse: 'Page View',
    viewContent: 'View Content',
    addToCart: 'Add to Cart',
    startCheckout: 'Initiate Checkout',
    purchase: 'Complete payment',
    addPaymentInfo: 'Add payment info',
  };
  var external_id = localStorage.getItem('external_id_tik_tok_pixel');
  var user_agent = localStorage.getItem('user_agent');
  var pageReferrer = '';
  var currency = localStorage.getItem('currency');
  var cart_url = '//' + window.location.hostname + '/cart.json';
  var itemInCart;
  var arrayTikTokPixelCapiTrackNew = JSON.parse(
    localStorage.getItem('arrayTikTokPixelCapiTrackNew')
  );
  var arrayTikTokPixelTrackNew = JSON.parse(localStorage.getItem('arrayTikTokPixelTrackNew'));
  var ttclid = JSON.parse(localStorage.getItem('ttclid'));
  var shop = localStorage.getItem('shop');

  var ip = null;
  var ot_ttclid = null;
  var tik_tok_utm_parameter = otTikTokPixelDetectCampaign();
  var checkStoreNewOmegaTikTok = null;
  let dayCheckNewStoreVersionAtcWebPixel = '2024-11-06';

  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    (ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
    ]),
      (ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      });
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    (ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
        ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    }),
      (ttq.load = function (e, n) {
        var i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        (ttq._i = ttq._i || {}),
          (ttq._i[e] = []),
          (ttq._i[e]._u = i),
          (ttq._t = ttq._t || {}),
          (ttq._t[e] = +new Date()),
          (ttq._o = ttq._o || {}),
          (ttq._o[e] = n || {});
        var o = document.createElement('script');
        (o.type = 'text/javascript'), (o.async = !0), (o.src = i + '?sdkid=' + e + '&lib=' + t);
        var a = document.getElementsByTagName('script')[0];
        a.parentNode.insertBefore(o, a);
      });
    ttq.checkOmega = function () {
      if (arguments.length > 0) {
        var oh, nh, ih, event_id;
        if (typeof arguments[0] == 'string') {
          oh = arguments[0];
        }
        if (typeof arguments[1] == 'string') {
          nh = arguments[1];
        }
        if (typeof arguments[2] == 'object') {
          ih = arguments[2];
        }
        if (typeof arguments[3] == 'string') {
          event_id = arguments[3];
          console.log('event_id: ' + event_id);
        } else if (typeof event_id == 'undefined') {
          let external_id = localStorage.getItem('external_id_tik_tok_pixel');
          event_id = getEventID(external_id);
          console.log('Create event_id: ' + event_id);
        }
        if (
          'string' == typeof oh &&
          '' != oh.replace(/\s+/gi, '') &&
          'string' == typeof nh &&
          nh.replace(/\s+/gi, '')
        ) {
          ttq.load(oh);
          ttq.page();
          // const user_infor = JSON.parse(localStorage.getItem('user_infor'))||{};
          // const {email = '', phone_number = '', external_id = ''} = user_infor;
          // ttq.instance(oh).identify({
          //   email,
          //   phone_number,
          //   external_id,
          // });
          switch (nh) {
            case 'StartCheckout':
              ttq.instance(oh).track('InitiateCheckout', ih, { event_id: event_id });
              break;
            case 'Purchase':
              let user_information = null;
              try {
                user_information = JSON.parse(localStorage.getItem('user_information')) || {};
              } catch {
              }
              ttq.instance(oh).identify({
                email: user_information?.email,
                phone_number: user_information?.phone_number,
                external_id: user_information?.external_id,
              });
              ttq.instance(oh).track('CompletePayment', ih, { event_id: event_id });
              break;
            case 'ViewContent':
            case 'Search':
            case 'AddToCart':
            case 'AddPaymentInfo':
              ttq.instance(oh).track('AddPaymentInfo', ih, { event_id: event_id });
              break;
            case 'Lead':
            case 'CompleteRegistration':
            case 'Checkout':
            case 'AddToWishlist':
              ttq.instance(oh).track(nh, ih, { event_id: event_id });
              break;
            default:
              return;
          }
        }
      }
    };

    //part2
  })(window, document, 'ttq');
  if (typeof $ == 'undefined') {
    javascript: (function (e, s) {
      e.src = s;
      e.onload = function () {
        $ = jQuery.noConflict();
      };
      document.head.appendChild(e);
    })(
      document.createElement('script'),
      'https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js'
    );
  }
  function trackEventsAPITikTok($, data) {
    if (data.action !== 'Purchase') {
      $.ajax({
        url: `${rootLinkTikTokPixel}/api/external/events-api`,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data),
      })
        .done((response) => { })
        .fail((error) => {
          console.log(error);
        });
    }
  }

  function generateExternalID(length) {
    var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join('');
  }

  function getEventID(external_id) {
    return external_id + randomStringNumber();
  }

  function otConvertPrice(number) {
    if (Number(number) % 1 !== 0) {
      return parseFloat(number).toFixed(2);
    } else {
      return number;
    }
  }



  window.omegaTikTokCallbackIC = async function (event) {
    const cart = event.data?.checkout?.lineItems || event.data?.cart?.lines;
    await getIP().then((data) => {
      let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/;
      ip = data.match(ipRegex)[0];
    });
    console.log("11111111: ", cart);
    console.log(" event.data?.checkout: ",  event.data?.checkout);
    if (cart.length > 0) {
      let arrayContent = [];
      $.each(cart, function (index, value) {
        //Detect type content_type
        let content_id = value?.variant?.product?.id || value?.merchandise?.id;
        let content_type = 'product_group';
        //Detect type content_type
        arrayContent.push({
          content_id: content_id + '',
          content_type: content_type,
          content_name: value?.title || value?.merchandise?.title,
          quantity: value?.quantity,
          price: value?.variant?.price.amount || value?.merchandise?.price.amount || 0,
        });
      });
      arrayTikTokPixelTrackNew.forEach(async function (element, index) {
        ttq.checkOmega(`${element}`, 'StartCheckout', {
          contents: arrayContent,
          currency: event.data?.checkout?.totalPrice?.currencyCode || event.data?.cart?.cost?.totalAmount?.currencyCode,
          value: event.data?.checkout?.totalPrice?.amount || event.data?.cart?.cost?.totalAmount?.amount,
        });
      });
      if (arrayTikTokPixelCapiTrackNew && arrayTikTokPixelCapiTrackNew.length > 0) {
        let external_id = localStorage.getItem('external_id_tik_tok_pixel');
        let event_id = getEventID(external_id);
        let referrerDocument = document.referrer;
        trackEventsAPITikTok($, {
          utm: tik_tok_utm_parameter?.ttclid ? tik_tok_utm_parameter : null,
          referrer: referrerDocument,
          action: 'StartCheckout',
          event: 'StartCheckout',
          eventShowTool: EVENT_NAME_TOOL.startCheckout,
          event_id: event_id,
          url: pageURL,
          pixel_ids: arrayTikTokPixelCapiTrackNew,
          shop: shop,
          ip: ip !== null ? ip : '',
          user_agent: user_agent,
          external_id: external_id,
          contents: arrayContent,
          currency: event.data?.checkout?.totalPrice?.currencyCode || event.data?.cart?.cost?.totalAmount?.currencyCode,
          value: event.data?.checkout?.totalPrice?.amount || event.data?.cart?.cost?.totalAmount?.amount,
          ttclid: ttclid,
          ip_source: ip ?? null,
          products: cart ?? null

        });
        if (localStorage.getItem('enable_deduplication') == '1') {
          arrayTikTokPixelCapiTrackNew.forEach(async function (element, index) {
            ttq.checkOmega(
              `${element}`,
              'StartCheckout',
              {
                contents: arrayContent,
                currency: event.data?.checkout?.totalPrice?.currencyCode || event.data?.cart?.cost?.totalAmount?.currencyCode,
                value: event.data?.checkout?.totalPrice?.amount || event.data?.cart?.cost?.totalAmount?.amount,
              },
              event_id
            );
          });
        }
      }
    }
  };

  window.omegaTiktokCallbackPaymentInfo = async function (event) {
    const lineItems = event.data.checkout.lineItems;
    const currency = event.data.checkout.totalPrice.currencyCode;
    const value = event.data.checkout.totalPrice.amount;

    await getIP().then((data) => {
      let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/;
      ip = data.match(ipRegex)[0];
    });
    if (lineItems.length > 0) {
      let arrayContent = [];
      $.each(lineItems, function (index, value) {
        //Detect type content_type
        let content_id = value.variant.product.id;
        let content_type = 'product_group';
        //Detect type content_type
        arrayContent.push({
          content_id: content_id + '',
          content_type: content_type,
          content_name: value.title,
          quantity: value.quantity,
          price: value.variant.price.amount,
        });
      });

      arrayTikTokPixelTrackNew && arrayTikTokPixelTrackNew.forEach(async function (element, index) {
        ttq.checkOmega(`${element}`, 'AddPaymentInfo', {
          contents: arrayContent,
          currency: currency,
          value: value,
        });
      });
      if (arrayTikTokPixelCapiTrackNew && arrayTikTokPixelCapiTrackNew.length > 0) {
        let external_id = localStorage.getItem('external_id_tik_tok_pixel');
        let event_id = getEventID(external_id);
        let referrerDocument = document.referrer;
        getInformationCustomerHash(external_id, event).then((userInformation) => {
          trackEventsAPITikTok($, {
            utm: tik_tok_utm_parameter?.ttclid ? tik_tok_utm_parameter : null,
            referrer: referrerDocument,
            action: 'AddPaymentInfo',
            event: 'AddPaymentInfo',
            eventShowTool: EVENT_NAME_TOOL.addPaymentInfo,
            event_id: event_id,
            url: pageURL,
            pixel_ids: arrayTikTokPixelCapiTrackNew,
            shop: shop,
            ip: ip !== null ? ip : '',
            user_agent: user_agent,
            external_id: external_id,
            contents: arrayContent,
            currency: currency,
            user: userInformation,
            value: value,
            ttclid: ttclid,
            products: lineItems ?? null
          });
          if (localStorage.getItem('enable_deduplication') == '1') {
            arrayTikTokPixelCapiTrackNew.forEach(async function (element, index) {
              ttq.checkOmega(
                `${element}`,
                'AddPaymentInfo',
                {
                  contents: arrayContent,
                  currency: currency,
                  value: value,
                },
                event_id
              );
            });
          }
        });
      }
    }
  };

  window.omegaTiktokCallbackPurchase = async function (event) {
    let arrayContent = [];
    var productIds = [];

    event.data.checkout.lineItems.forEach(function (item, index) {
      if (item.variant.title != '' && item.variant.title != undefined) {
        var prod_name = item.title + ' - ' + item.variant.title;
      } else {
        var prod_name = item.title;
      }
      productIds.push(item.variant.product.id);
      //Detect type content_type
      let content_type = 'product_group';
      let content_id = item.variant.id;
      // if (content_type_event == CONTENT_TYPE_IS_PRODUCT) {
      //   content_id = item.variant_id;
      //   content_type = 'product';
      // }
      //Detect type content_type

      arrayContent.push({
        content_id: `${content_id}`,
        content_type: content_type,
        content_name: prod_name,
        quantity: item.quantity,
        price: otConvertPrice(item.variant.price.amount),
      });
    });
    var enable_deduplication = 1;
    var shopPurchase = shop;
    addEventPurchaseInThankYouPageTikTok($, arrayContent, productIds, enable_deduplication, shopPurchase, event);
  }

  async function addEventPurchaseInThankYouPageTikTok(
    $,
    arrayContent,
    productIds,
    enable_deduplication,
    shopPurchase,
    event
  ) {
    const results = await getAllTikTokPixelInThankYouPage(productIds, shopPurchase);
    if (typeof results['pixels'] !== 'undefined' && typeof results['pixelsCapi'] !== 'undefined') {
      window.arrayTikTokPixelCapiTrackNew = results['pixelsCapi'];
      window.arrayTikTokPixel = results['pixelCapi_information'];
      var pixels = results['pixels'];
      var pixelsCapi = results['pixelsCapi'];
      const currency = event.data.checkout.totalPrice.currencyCode;

      if (pixels.length > 0) {
        pixels.forEach(async function (element, index) {
          ttq.checkOmega(`${element}`, 'Purchase', {
            contents: arrayContent,
            currency: `${currency}`,
            value: otConvertPrice(event?.data?.checkout?.subtotalPrice?.amount),
          });
          if (shop == 'veralo-br.myshopify.com') {
            ttq.checkOmega(`${element}`, 'Checkout', {
              contents: arrayContent,
              currency: `${currency}`,
              value: otConvertPrice(event?.data?.checkout?.subtotalPrice?.amount),
            });
          }
        });
      }
      if (pixelsCapi.length > 0) {
        let external_id = generateExternalID(36);
        let event_id = event.data.checkout.order.id;

        getInformationCustomerHash(external_id, event).then((user_infomartion) => {
          try {
            localStorage.setItem("user_information", JSON.stringify(user_infomartion));
          } catch {
          }
          let referrerDocument = document.referrer;
          trackEventsAPITikTok($, {
            utm: tik_tok_utm_parameter?.ttclid ? tik_tok_utm_parameter : null,
            referrer: referrerDocument,
            action: 'Purchase',
            event: 'Purchase',
            eventShowTool: EVENT_NAME_TOOL.purchase,
            event_id: event_id,
            url: pageURL,
            pixel_ids: pixelsCapi,
            shop: event?.context?.window?.location?.host,
            ip: ip !== null ? ip : '',
            user_agent: user_agent,
            external_id: external_id,
            contents: arrayContent,
            currency: `${currency}`,
            value: otConvertPrice(event?.data?.checkout?.subtotalPrice?.amount),
            user: user_infomartion,
            order_id: event?.data?.checkout?.order?.id,
            ttclid: ot_ttclid,
            ip_source: ip ?? null,
            products: arrayContent ?? null

          });
          if (enable_deduplication == 1) {
            pixelsCapi.forEach(async function (element, index) {
              ttq.checkOmega(
                `${element}`,
                'Purchase',
                {
                  contents: arrayContent,
                  currency: `${currency}`,
                  value: otConvertPrice(event?.data?.checkout?.subtotalPrice?.amount),
                },
                event_id.toString()
              );
            });
          }
        });
      }
    }
  }

  function getAllTikTokPixelInThankYouPage(productIDs, shopPurchase) {
    return new Promise((resolve) => {
      $.ajax({
        type: 'GET',
        data: { product_ids: productIDs, shop: shopPurchase || '' },
        url: `${rootLinkTikTokPixel}/api/external/pixels/purchase`,
        dataType: 'json',
      }).done((result) => {
        if (typeof result == 'string') {
          result = JSON.parse(result);
        }
        resolve(result.data);
      });
    });
  }

  async function getInformationCustomerHash(external_id, event) {
    let externalID = localStorage.getItem('external_id_tik_tok_pixel');
    let email = await sha256(event?.data?.checkout?.email ? event?.data?.checkout?.email : '');

    // If the country code is 86, then do not include country code
    const phoneNumber = event?.data?.checkout?.phone ?? '';
    const pattern = /^\+86/;
    if (pattern.test(phoneNumber)) {
      phoneNumber = phoneNumber.replace(pattern, '');
    }
    let phone = await sha256(phoneNumber);

    return {
      external_id: externalID,
      phone_number: phone,
      email: email,
    };
  }

  async function sha256(message) {
    const msgBuffer = new TextEncoder('utf-8').encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => ('00' + b.toString(16)).slice(-2)).join('');
  }
  function otTikTokPixelCheckExpireApp($, rootLinkTikTokPixel, shop) {
    'use strict';
    return new Promise((resolve) => {
      $.ajax({
        type: 'GET',
        data: { shop: shop },
        url: `${rootLinkTikTokPixel}/api/external/check-expire`,
        dataType: 'json',
      }).done((result) => {
        resolve(result.data);
      });
    });
  }



  setInterval(() => {
    // Track Start Checkout
    var EVENT_CHECKOUT = JSON.parse(localStorage.getItem('OT_DATA_TRIGGER_CHECKOUT_TIKTOK'))
      || JSON.parse(localStorage.getItem('fk_checkout_started_event_ic_tik_tok_omega'));

    if (EVENT_CHECKOUT != undefined) {
      omegaTikTokCallbackIC(EVENT_CHECKOUT?.dataEvent || EVENT_CHECKOUT);
      localStorage.removeItem('OT_DATA_TRIGGER_CHECKOUT_TIKTOK');
      localStorage.removeItem('fk_checkout_started_event_ic_tik_tok_omega');
    }

    // Track Add Payment Info
    var EVENT_PAYMENT_INFO = JSON.parse(
      localStorage.getItem('OT_DATA_TRIGGER_PAYMENT_INFO_TIKTOK')
    );

    if (EVENT_PAYMENT_INFO != undefined) {
      omegaTiktokCallbackPaymentInfo(EVENT_PAYMENT_INFO);
      localStorage.removeItem('OT_DATA_TRIGGER_PAYMENT_INFO_TIKTOK');
    }

    // Track Purchase
    var EVENT_PURCHASE = JSON.parse(
      localStorage.getItem('OT_DATA_TRIGGER_PURCHASE_TIKTOK')
    );

    if (EVENT_PURCHASE != undefined) {
      omegaTiktokCallbackPurchase(EVENT_PURCHASE);
      localStorage.removeItem('OT_DATA_TRIGGER_PURCHASE_TIKTOK');
    }
  }, 1000);

  function randomStringNumber() {
    let characters = '0123456789';
    let randstring = '';
    for (let i = 0; i < 10; i++) {
      randstring += characters[Math.floor(Math.random() * 9)];
    }
    return randstring;
  }

  function getIP() {
    return fetch('https://www.cloudflare.com/cdn-cgi/trace').then((res) => res.text());
  }
  function otConvertPageUrl() {
    var fb_pageURL = window.location.href;
    var from_slice = fb_pageURL.indexOf('/wpm@');
    var to_slice = fb_pageURL.indexOf('/sandbox/modern') + '/sandbox/modern'.length;
    var slice_replace = fb_pageURL.slice(from_slice, to_slice);
    return fb_pageURL.replace(slice_replace, '');
  }
}